import React, { Component } from "react";
import "./PestControlOperatorSearch.css";
import { SearchForm } from "./SearchForm";
import { SearchResults } from "./SearchResults";
import queryString from "query-string";
import { navigate } from "@reach/router";
import { FormattedMessage } from "react-intl";
import { parseLang, constructApiUrl, isTermListValid, isTermValid } from "../utils";
import { Helmet } from "react-helmet";
import { CompetencyDescriptions } from "../components/CompetencyDescriptions";

export class PestControlOperatorSearch extends Component {
  initialState = {
    selectedMunicipalities: [],
    page: 0,
    pageSize: 10,
    personSearchText: "",
    companySearchText: "",
    officeSearchText: "",
    businessIdSearchText: "",
    sortColumn: "Nimi",
    sortDirection: "asc",
    // these are not reflected in query params
    totalRows: 0,
    searchResults: null,
    searching: false,
    searchError: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.initialState,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);


    // set initial local state from query params
    this.setState(
      {
        selectedMunicipalities: query.m || [],
        page: Number(query.p) || 0,
        personSearchText: query.ps || "",
        companySearchText: query.cs || "",
        officeSearchText: query.os || "",
        businessIdSearchText: query.bs || "",
        sortColumn: query.sc || "Nimi",
        sortDirection: query.sd || "asc",
      }
    );
  }


  resetForm = () => {
    this.setState(this.initialState);
    this.resetQueryString();
  };

  isFormValid = () => {
    if (isTermListValid(this.state.personSearchText) ||
      isTermListValid(this.state.companySearchText) ||
      isTermListValid(this.state.businessIdSearchText) ||
      isTermListValid(this.state.officeSearchText) ||
      this.state.selectedMunicipalities.length) {
      return true;
    }
    return false;
  };

  buildQueryString = () => {
    return queryString.stringify({
      person: this.state.personSearchText,
      businessName: this.state.companySearchText,
      officeName: this.state.officeSearchText,
      businessId: this.state.businessIdSearchText,
      page: this.state.page,
      pageSize: this.state.pageSize,
      municipality: this.state.selectedMunicipalities,
      order: `${!this.state.sortColumn || this.state.sortDirection === "asc" ? "" : "-"}${this.state.sortColumn
        }`,
    });
  };

  // updates new query parameters to current url
  navigateWithQuery = query => {
    const { location, uri } = this.props;
    const stringified = queryString.stringify({
      ...queryString.parse(location.search),
      ...query,
    });
    navigate(`${uri}?${stringified}`, { replace: true });
  };

  // this is called when user selects municipality from multiselect
  municipalitySelected = nextValues => {
    const queryValues = nextValues.map(value => value.value);
    this.setState({ selectedMunicipalities: queryValues }, () => {
      this.navigateWithQuery({ m: queryValues });
    });
  };

  changePage = nextPage => {
    this.setState({ page: nextPage }, () => {
      this.navigateWithQuery({ p: nextPage });
      this.fetch();
    });
  };

  setPersonSearchText = event => {
    const personSearchText = event.currentTarget.value;
    this.setState({ personSearchText }, () => {
      this.navigateWithQuery({ ps: personSearchText });
    });
  };

  setCompanySearchText = event => {
    const companySearchText = event.currentTarget.value;
    this.setState({ companySearchText }, () => {
      this.navigateWithQuery({ cs: companySearchText });
    });
  };

  setOfficeSearchText = event => {
    const officeSearchText = event.currentTarget.value;
    this.setState({ officeSearchText }, () => {
      this.navigateWithQuery({ os: officeSearchText });
    });
  };

  setBusinessIdSearchText = event => {
    const businessIdSearchText = event.currentTarget.value;
    this.setState({ businessIdSearchText }, () => {
      this.navigateWithQuery({ bs: businessIdSearchText });
    });
  };

  sortChanged = sortColumn => {
    const sortDirection = this.state.sortDirection === "asc" ? "desc" : "asc";
    if (this.state.sortColumn === sortColumn) {
      this.setState({ sortDirection }, () => {
        this.navigateWithQuery({ sd: sortDirection });
        this.fetch();
      });
    } else {
      this.setState({ sortColumn, sortDirection }, () => {
        this.navigateWithQuery({ sc: sortColumn, sd: sortDirection });
        this.fetch();
      });
    }
  };

  resetQueryString = () => {
    this.navigateWithQuery({
      sd: [],
      sc: [],
      p: [],
      m: [],
      ps: [],
      cs: [],
      os: [],
      bs: []
    });
  };

  fetch = async setPage => {
    await this.setState(state => ({
      ...state,
      page: Number.isInteger(setPage) ? setPage : state.page,
      searching: !state.searching,
      searchResults: null,
    }));

    if (Number.isInteger(setPage)) this.navigateWithQuery({ p: setPage });

    const apiUrl = process.env.REACT_APP_SEARCH_PESTCONTROL_OPERATORS;

    try {
      const query = this.buildQueryString();
      const response = await fetch(constructApiUrl(apiUrl, query));
      const responseJSON = await response.json();
      const { totalRows, results } = responseJSON;
      this.setState({
        searchResults: results,
        totalRows: totalRows,
        searching: false,
        searchError: false,
      });
    } catch (error) {
      this.setState({
        searchResults: [],
        totalRows: 0,
        searching: false,
        searchError: true,
      });
    }
  };

  render() {
    const queryLang = parseLang(this.props.location.search);
    const { location } = this.props;

    return (
      <div className='PestControlOperatorSearch'>
        <FormattedMessage tagName='h1' id='pestControlOperatorSearch.header' />
        <h2>
          <CompetencyDescriptions locale={queryLang} location={location} />
        </h2>
        <FormattedMessage id='pestControlOperatorSearch.header'>
          {refrigrationTitle => <Helmet title={refrigrationTitle} />}
        </FormattedMessage>

        <SearchForm
          fetch={this.fetch}
          isFormValid={this.isFormValid}
          locale={queryLang}
          personSearchText={this.state.personSearchText}
          updatePersonSearchText={this.setPersonSearchText}
          selectedMunicipalities={this.state.selectedMunicipalities}
          updateMunicipalities={this.municipalitySelected}
          companySearchText={this.state.companySearchText}
          updateCompanySearchText={this.setCompanySearchText}
          officeSearchText={this.state.officeSearchText}
          updateOfficeSearchText={this.setOfficeSearchText}
          businessIdSearchText={this.state.businessIdSearchText}
          updateBusinessIdSearchText={this.setBusinessIdSearchText}
          searching={this.state.searching}
          resetForm={this.resetForm}
        />
        <SearchResults
          changePage={this.changePage}
          currentPage={this.state.page}
          pageSize={this.state.pageSize}
          results={this.state.searchResults}
          totalRows={this.state.totalRows}
          searching={this.state.searching}
          searchError={this.state.searchError}
          sortColumn={this.state.sortColumn}
          sortDirection={this.state.sortDirection}
          updateSort={this.sortChanged}
          locale={queryLang}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PestControlOperatorSearch/PestControlOperatorSearch.js